import { DateTime } from "luxon";

export function clampEditTime({ start, end }: { start: DateTime; end: DateTime }) {
  // Target day is tomorrow
  const tomorrow = DateTime.now().plus({ days: 1 }).startOf("day");
  const tomorrowDateStr = tomorrow.toISODate(); // e.g. "2025-09-04"

  let clampedStart = start;
  let clampedEnd = end;

  const startDateStr = start.toISODate();
  const endDateStr = end.toISODate();
  const duration = end.diff(start, "minutes").as("minutes");
  const tomorrowEnd = tomorrow.plus({ hours: 23, minutes: 59 });

  // 🕛 If start and end is completely not on the correct day → clamp to 23:59 tomorrow
  if (
    startDateStr === endDateStr &&
    (endDateStr !== tomorrowDateStr || startDateStr !== tomorrowDateStr)
  ) {
    clampedEnd = tomorrowEnd;
    clampedStart = clampedEnd.minus({ minutes: duration });

    return { clampedStart, clampedEnd };
  }

  // 🕛 If start is not on the correct day → clamp to 00:00 tomorrow
  if (startDateStr !== tomorrowDateStr) {
    clampedStart = tomorrow;
    clampedEnd = clampedStart.plus({ minutes: duration });

    return { clampedStart, clampedEnd };
  }

  // 🕘 If end is not on the correct day → clamp to 23:59 tomorrow
  if (endDateStr !== tomorrowDateStr) {
    clampedEnd = tomorrowEnd;
    clampedStart = clampedEnd.minus({ minutes: duration });

    return { clampedStart, clampedEnd };
  }

  return { clampedStart, clampedEnd };
}
